import { SampleCreatedWith } from '../types';

export const SAMPLE_MADE_WITH_ITEMS: Array<keyof SampleCreatedWith> = [
  'fabric',
  'trim',
  'label',
  'wash_color',
];

export const FABRIC_SECTION_NAMES = [
  'self',
  'contrast',
  'lining',
  'filling',
  'coating',
  'backing',
] as const;

export const PROTO_DEVELOPMENT_COLORS: { [key: string]: string } = {
  'Sample Request': '#0030DE',
  'Buyer Requested': '#C8ACFF',
  'Vendor Sample': '#FF2900',
  LUXE: '#000000',
  'PD Development': '#FF2900',
};

export const SAMPLE_TYPE_COLORS: { [key: string]: string } = {
  'Pre-Production': '#7AC5E2',
  TOP: '#00CC00',
  Fit: '#FFEF10',
  'First Sample': '#FF64F2',
  Block: '#d4d4d4',
};
